import {BaseEntity} from "../common/base-entity";
import {FormControl} from "rx-form-mapper";

export class ReferralDocument extends BaseEntity {
    id: number;
    @FormControl()
    description: string;
    @FormControl()
    documentName: string;
    @FormControl()
    referralId: number;
    @FormControl()
    virusScanStatus: VirusScanStatus ;
    @FormControl()
    sourceId: string;
    @FormControl()
    documentType: string;

    isVirusClean() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.CLEAN;
    }

    isVirusInfected() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.INFECTED;
    }

    isVirusPending() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.PENDING;
    }

    isVirusInProgress() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.IN_PROGRESS;
    }
}

export type VirusScanStatus = 'INFECTED' | 'PENDING' | 'IN_PROGRESS' | 'CLEAN';

export const VirusScanStatusValue = {
    INFECTED : 'INFECTED',
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    CLEAN: 'CLEAN'
};